module.exports = __webpack_public_path__ + "static/media/7.e8d2c49c.jpg";